export const SERVICE_HISTORY_QUERY = `
  query ServiceHistoryRecords($vin: String, $repairOrderId: String, $ffmCompanyId: String, $limit: Int, $offset: Int) {
    getServiceHistory(vin: $vin, repairOrderId: $repairOrderId, ffmCompanyId: $ffmCompanyId, limit: $limit, offset: $offset) {
      totalCount
      hasNextPage
      items {
        vin
        repairOrderId
        dataSource
        url
        repairOrderCloseDate
        totalAmount
        odometerReading
        engineHours
        serviceDescription
        ffmCompanyId
        partsTotalAmount
        laborTotalAmount
        miscellaneousTotalAmount
        taxTotalAmount
      }
    }
  }
`;
const DEFAULT_GRAPHQL_ENDPOINT = "/fis/sm/graphql";
function getGraphqlEndpoint() {
    return process.env.BFF_GRAPHQL_ENDPOINT || DEFAULT_GRAPHQL_ENDPOINT;
}
export async function fetchGraphqlPayload(query, variables) {
    const response = await fetch(getGraphqlEndpoint(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ query, ...(variables ? { variables } : {}) }),
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch service history: ${response.status}`);
    }
    const payload = (await response.json());
    if (Array.isArray(payload.errors) && payload.errors.length > 0) {
        const firstError = payload.errors[0]?.message || "GraphQL query failed";
        throw new Error(firstError);
    }
    return payload;
}
